import React, { useState, useEffect, useRef } from "react";
import { TableHead, Table, TableBody, TableCell, TableContainer, TableRow, TableFooter, TablePagination, Card, Box, Container, Chip, FormLabel, TableSortLabel } from "@mui/material";
import Api from "../../network/Api";
import TypingIndicator from "../Shared/TypingIndicator";
import { Lesson } from "../../types/Lessons";
import { NavLink } from "react-router-dom";
import { CommentButton, ItemButtonActions, StateButton } from "./Buttons";
import { StartProps } from "../Layouts/MainApp";
import dayjs from "dayjs";

const LessonsList = (props: StartProps & ItemButtonActions) => {

  const [lessons, setLessons] = useState<Array<Lesson>>();
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const scrollTopRef = useRef();

  useEffect(() => {
    Api.get(`/lessons?limit=${limit}&page=${page}`).then(result => {
      setLessons(result.items);
      setTotal(result.total);
      scrollTopRef.current?.scrollIntoView({ behavior: "smooth" });
    });
  }, [limit, page]);

  return <Box sx={{overflowY: 'auto', flexGrow: 1, width: "100%", pt: 3, pb: 5}}>
    <Container maxWidth="xl">
      <Card sx={{p: "0 !important"}}>
        <TableContainer sx={{width: '100%', overflowX: 'auto'}}>
          <Table>
            <TableHead ref={scrollTopRef}>
              <TableRow>
                <TableCell sx={{ position: "sticky", left: 0, zIndex: 1 }}>
                  <TableSortLabel
                    active={false}
                    direction="desc"
                    onClick={() => {}}
                    sx={{color: "inherit !important"}}
                  >
                    Lesson learned
                  </TableSortLabel>
                </TableCell>
                <TableCell>Origin</TableCell>
                <TableCell align="center">Reviewed</TableCell>
                <TableCell align="center">Comments</TableCell>
                <TableCell>Root causes</TableCell>
                <TableCell>
                  <TableSortLabel
                    active
                    direction="desc"
                    onClick={() => {}}
                    sx={{color: "inherit !important"}}
                  >
                    Created at
                  </TableSortLabel>
                </TableCell>
                <TableCell>Last updated</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {lessons ? lessons.map((lesson) => {
                return <TableRow
                  key={lesson.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell sx={{ position: "sticky", left: 0, zIndex: 1, right: 0 }}>
                    <NavLink to={`/lessons/${lesson.id}`}>{lesson.headline}</NavLink>
                  </TableCell>
                  <TableCell>{lesson.origin}</TableCell>
                  <TableCell align="center" width="10%"><StateButton lesson={lesson} onOpen={props.onOpen} /></TableCell>
                  <TableCell align="center" width="15%"><CommentButton lesson={lesson} size="small" onOpen={props.onOpen} /></TableCell>
                  <TableCell>{[...new Set(lesson.causes.map(cause => cause.category.name))].map(item => <Chip key={item} label={item} sx={{m: 0.5}} />)}</TableCell>
                  <TableCell><small className="text-secondary">{dayjs.unix(lesson.created_at).format("lll")}</small></TableCell>
                  <TableCell><small className="text-secondary">{dayjs.unix(lesson.updated_at).format("lll")}</small></TableCell>
                </TableRow>
              }) : <TableRow>
                <TableCell colSpan={5} sx={{justifyItems: "center", padding: 5}}>
                  <TypingIndicator />
                </TableCell>
              </TableRow>}
            </TableBody>

            <TableFooter>
              <TableRow>
                <TablePagination 
                  count={total} 
                  page={page-1}
                  rowsPerPage={limit}
                  onPageChange={(e, page) => setPage(page+1)}
                  onRowsPerPageChange={e => setLimit(e.target.value)}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Card>
    </Container>
  </Box>
};

export default LessonsList;
